import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, useRequestData } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

import { getClassesForItem } from '../utils/getClassesForItem';

const WhyBuyItem = ({ totalCount, count, item: { title, iconId } }) => {
	const labels = useLabels();
	const { deviceType } = useRequestData();
	const isMobile = deviceType !== 'DESKTOP';
	const classesforItems = getClassesForItem(totalCount, count, isMobile);

	return (
		<div
			className={setClassNames([
				'why-buy-item',
				'd-flex',
				'flex-column',
				'col-sm-6',
				'col-xs-6',
				'px-1',
				'px-md-6',
				'px-sm-4',
				classesforItems
			])}
		>
			<i
				className={`ddc-icon ddc-icon-${iconId} align-self-center mt-7 mb-3`}
			/>
			<p className="text-center description px-4 px-sm-0 px-md-0 mb-6">
				{labels.get(title)}
			</p>
		</div>
	);
};

WhyBuyItem.propTypes = {
	totalCount: PropTypes.number.isRequired,
	count: PropTypes.number.isRequired,
	item: PropTypes.shape({
		iconId: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired
	}).isRequired
};

export default WhyBuyItem;
